import { render } from "./menuBottomMob.vue?vue&type=template&id=4292851f&scoped=true"
import script from "./menuBottomMob.vue?vue&type=script&lang=js"
export * from "./menuBottomMob.vue?vue&type=script&lang=js"

import "./menuBottomMob.vue?vue&type=style&index=0&id=4292851f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4292851f"]])

export default __exports__